var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-numeration",
    attrs: { owner: _vm._self },
    scopedSlots: _vm._u(
      [
        {
          key: "simple",
          fn: function () {
            return [
              _c("span", [_vm._v(_vm._s(_vm.value))]),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(_vm._s(_vm.errorsMsg)),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              !_vm.readOnly
                ? _c(
                    "el-input",
                    {
                      class: { "ds-error-border": _vm.errors.length > 0 },
                      attrs: {
                        placeholder: _vm.placeholder,
                        type: "text",
                        disabled: true,
                      },
                      model: {
                        value: _vm.inputValue,
                        callback: function ($$v) {
                          _vm.inputValue = $$v
                        },
                        expression: "inputValue",
                      },
                    },
                    [
                      _vm.showBtn
                        ? _c("i", {
                            class: [
                              "iconfont",
                              _vm.btnIcon
                                ? _vm.btnIcon + " icon-" + _vm.btnIcon
                                : "icon-bianjisekuai",
                            ],
                            attrs: { slot: "suffix" },
                            on: { click: _vm.handleIconClick },
                            slot: "suffix",
                          })
                        : _vm._e(),
                    ]
                  )
                : _c("div", { staticClass: "ds-form-readonly" }, [
                    _c("span", [_vm._v(_vm._s(_vm.value))]),
                  ]),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(_vm._s(_vm.errorsMsg)),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }